import { Chip, Divider, Stack, Typography } from '@mui/material';
import type { HomePageTopGrossing } from '@weft/api-definition';
import { Price } from 'apps/app/src/components/design/Price';
import { PercentageChip } from '../PercentageChip';

type HomePageTopCustomersSectionProps = {
  customerData: HomePageTopGrossing
  index: number
};

export const HomePageTopCustomersListItem: React.FC<HomePageTopCustomersSectionProps> = ({ customerData: { currentRevenue, currency, id, name, previousRevenue }, index }) => {
  return (
    <Stack
      key={id}
      component="a"
      href={`../customers/${id}`}
      direction="row"
      alignItems="center"
      width="100%"
      paddingX={3}
      gap={2}
    >
      <Chip
        label={`#${index + 1}`}
        size='small'
      />
      <Typography>{name}</Typography>
      <Stack
        marginLeft="auto"
        direction="row"
        divider={<Divider
          orientation="vertical"
          flexItem
                 />}
        gap={3}
      >
        <Stack 
          justifyContent="center"
          alignItems="flex-end"
        >
          <Price
            currency={currency}
            rounded
            variant='body1'
          >
            {currentRevenue}
          </Price>
          <Typography
            variant='caption'
            color={theme => theme.palette.text.disabled}
          >
            Revenue
          </Typography>
        </Stack>
        <Stack 
          justifyContent="center"
          alignItems="flex-end"
          gap={0.5}
        >
          <PercentageChip 
            newValue={currentRevenue}
            oldValue={previousRevenue}
          />
          <Typography
            variant='caption'
            color={theme => theme.palette.text.disabled}
          >
            Monthly change
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};